import React from "react";
import { GitCompare } from "lucide-react";
import type { DateRange } from "../../types/dashboard.types";

interface Props {
  enabled: boolean;
  onToggle: () => void;
  compareRange: DateRange;
  onChange: (r: DateRange) => void;
}

const DateInput: React.FC<{ value: string; onChange: (v: string) => void }> = ({ value, onChange }) => (
  <input
    type="date"
    value={value}
    onChange={e => onChange(e.target.value)}
    className="px-2 py-1 rounded-lg text-[11px] font-mono text-slate-700 border border-slate-200 bg-white
      focus:outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-100 transition-all cursor-pointer"
  />
);

const CompareToggle: React.FC<Props> = ({ enabled, onToggle, compareRange, onChange }) => (
  <div className="flex flex-wrap items-center gap-2">
    <button
      onClick={onToggle}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold border transition-all duration-150
        ${enabled
          ? "bg-indigo-600 text-white border-indigo-600 shadow-sm"
          : "bg-white text-slate-500 border-slate-200 hover:border-indigo-300 hover:text-indigo-600"
        }`}
    >
      <GitCompare size={12} />
      Comparer
    </button>

    {enabled && (
      <div className="flex items-center gap-1.5 animate-[fadeIn_0.2s_ease]">
        <span className="text-[10px] font-semibold text-slate-400 uppercase tracking-wider">vs</span>
        <DateInput
          value={compareRange.startDate}
          onChange={v => onChange({ ...compareRange, startDate: v })}
        />
        <span className="text-slate-300 text-xs">–</span>
        <DateInput
          value={compareRange.endDate}
          onChange={v => onChange({ ...compareRange, endDate: v })}
        />
      </div>
    )}
  </div>
);

export default CompareToggle;